import useI18n from '@/shared/hooks/useI18n'
import { BodyTd, HeaderTh, TableBody, TableBodyRow } from './typography'

interface MethodAggregatedEmission {
  specificEmbeddedDirect: number
  specificEmbeddedIndirect: number
}

export default function FinalizedReportSpecificEmbeddedEmissionsTable({
  methodAggregatedEmissions: { specificEmbeddedDirect, specificEmbeddedIndirect },
  columnNames,
  selectedPdfLanguage
}: {
  methodAggregatedEmissions: MethodAggregatedEmission
  columnNames?: {
    specificEmbeddedDirect: string
    specificEmbeddedIndirect: string
  }
  selectedPdfLanguage?: string
}) {
  const { numberFormatter3DecimalsGB, t } = useI18n()

  const tLng = { lng: selectedPdfLanguage }
  const localColumnNames = columnNames ?? {
    specificEmbeddedDirect: t(
      'finalizedReportDocument:emissions.specificEmbedded.table.specificDirect',
      tLng
    ),
    specificEmbeddedIndirect: t(
      'finalizedReportDocument:emissions.specificEmbedded.table.specificIndirect',
      tLng
    )
  }

  return (
    <table className="w-full text-center">
      <thead>
        <tr className="text-right">
          <HeaderTh>{localColumnNames.specificEmbeddedDirect}</HeaderTh>
          <HeaderTh>{localColumnNames.specificEmbeddedIndirect}</HeaderTh>
        </tr>
      </thead>
      <TableBody>
        <TableBodyRow>
          <BodyTd isNumeric>{numberFormatter3DecimalsGB(specificEmbeddedDirect)} tCO₂e/t</BodyTd>
          <BodyTd isNumeric>{numberFormatter3DecimalsGB(specificEmbeddedIndirect)} tCO₂e/t</BodyTd>
        </TableBodyRow>
      </TableBody>
    </table>
  )
}
